import { Box, ButtonBase, Typography } from '@mui/material';
import { FENCE_RISK_COLORS, RiskClassification } from 'app/config/constants';
import React from 'react';

const RISK_OPTIONS: { value: RiskClassification; label: string }[] = [
  { value: 'SAFE', label: 'Segura' },
  { value: 'UNSAFE', label: 'Insegura' },
  { value: 'CONTROL', label: 'Controle' },
];

interface Props {
  value: RiskClassification;
  onChange: (v: RiskClassification) => void;
  disabled?: boolean;
}

export const RiskClassificationSelector = ({ value, onChange, disabled = false }: Props) => {
  return (
    <Box
      role="radiogroup"
      aria-label="Classificação de risco"
      sx={{ display: 'flex', gap: '6px' }}
    >
      {RISK_OPTIONS.map(opt => {
        const isSelected = value === opt.value;
        const color = FENCE_RISK_COLORS[opt.value];

        return (
          <ButtonBase
            key={opt.value}
            role="radio"
            aria-checked={isSelected}
            aria-label={opt.label}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            focusRipple
            sx={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '6px',
              py: '7px',
              px: 1,
              borderRadius: '8px',
              border: '1.5px solid',
              borderColor: isSelected ? color : 'divider',
              bgcolor: isSelected ? `${color}18` : 'transparent',
              transition: 'all 0.15s ease',
              cursor: disabled ? 'default' : 'pointer',
              '&:hover': {
                borderColor: disabled ? (isSelected ? color : 'divider') : color,
                bgcolor: disabled ? (isSelected ? `${color}18` : 'transparent') : `${color}10`,
              },
              '&:focus-visible': {
                outline: `2px solid ${color}`,
                outlineOffset: 2,
              },
            }}
          >
            <Box
              aria-hidden="true"
              sx={{
                width: 10,
                height: 10,
                borderRadius: '50%',
                bgcolor: color,
                flexShrink: 0,
              }}
            />
            <Typography
              variant="body2"
              sx={{
                fontWeight: isSelected ? 600 : 400,
                color: isSelected ? color : 'text.secondary',
                fontSize: '0.8125rem',
                lineHeight: 1,
              }}
            >
              {opt.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};
